export default __webpack_public_path__ + "static/media/asset lock.6eacf412.png";